module.exports = __webpack_public_path__ + "img/careers.a486463b.svg";